import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header/index";
import Hero from "./components/Hero";
import Services from "./components/Services";
import RealEstate from "./components/RealEstate";
import Startups from "./components/Startups";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BlogPage from "./components/BlogPage";
import BlogPost from "./pages/BlogPost";
import RealEstatePage from "./pages/RealEstate";
import ContactPage from "./pages/Contact";
import CommissionCalculator from "./pages/CommissionCalculator";
import ClientLogin from "./pages/ClientLogin";
import ClientDashboard from "./pages/ClientDashboard";
import MarketingPlan from "./pages/MarketingPlan";
import SiteAddons from "./pages/SiteAddons";
import Animation from "./pages/Animation";
import ScrollToTop from "./components/common/ScrollToTop";
import "./styles/global.css";

function AppContent() {
  const location = useLocation();
  
  // Check if we're on a dashboard route
  const isDashboardRoute = location.pathname.startsWith('/dashboard') || 
                          location.pathname.startsWith('/marketing-plan') ||
                          location.pathname.startsWith('/site-addons');
  
  return (
    <div className="App">
      {/* Only show regular header on non-dashboard pages */}
      {!isDashboardRoute && <Header />}
      <ScrollToTop />
      
      <Routes>
        <Route path="/" element={
          <>
            <div id="home">
              <Hero />
            </div>
            
            <div id="services">
              <Services />
            </div>
            
            <div id="realestate">
              <RealEstate />
            </div>
            
            <div id="startups">
              <Startups />
            </div>
            
            <div id="contact">
              <Contact />
            </div>
          </>
        } />
        <Route path="/news" element={<BlogPage />} />
        <Route path="/news/:slug" element={<BlogPost />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/realestate" element={<RealEstatePage />} />
        <Route path="/media" element={<Animation />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/commission-calculator" element={<CommissionCalculator />} />
        <Route path="/client-login" element={<ClientLogin />} />
        <Route path="/dashboard/:token" element={<ClientDashboard />} />
        <Route path="/marketing-plan/:token" element={<MarketingPlan />} />
        <Route path="/site-addons/:token" element={<SiteAddons />} />
      </Routes>
      
      {/* Only show footer on non-dashboard pages */}
      {!isDashboardRoute && <Footer />}
    </div>
  );
}

function App() {
  return <AppContent />;
}

export default App;

